import { render } from "./Header.vue?vue&type=template&id=bfea2860"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfea2860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfea2860', __exports__)) {
    api.reload('bfea2860', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=bfea2860", () => {
    api.rerender('bfea2860', render)
  })

}


export default __exports__